// packages
const { h, Component } = require('preact');

// components
import LookupRow from './LookupRow';
import CountyInfo from './CountyInfo'
import data from '../../../../data/data.json';

// internal

class CountyViewer extends Component {
  constructor() {
    super();

    this.state = {}
    console.log('CountyViewer constructor called with props:', this.props);
  }
  
  render() {
    console.log('CountyViewer render called with props:', this.props);
    return (
      <div class="county-viewer">
        <CountyInfo 
          county={this.props.county.toUpperCase()}
        />
        <LookupRow
          county={this.props.county.toUpperCase()}
          data={data}
        />
      </div>
    )
  }
}

export default CountyViewer;
